{
  "BR01": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty - 24 Months / 1000 hrs (1st year, DC 1)",
    "CoverageAge": 12,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "BR011": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty - 24 Months / 1000 hrs (2nd year, DC 8)",
    "CoverageAge": 24,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "BR02": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty - 12 Months / Unlimited hrs (1st year, DC 1)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "BR021": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty - 24 Months / 3000 hrs (2nd year, DC 8)",
    "CoverageAge": 24,
    "CoverageHours": 3000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "DE01": {
    "CoverageDescriptionManual": "Stock/Demonstration use - 125 hrs",
    "CoverageAge": 120,
    "CoverageHours": 125,
    "IconText": "Demonstration",
    "IconType": "Demo"
  },
  "E00": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 60 Months / 480 hrs",
    "CoverageAge": 60,
    "CoverageHours": 480,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E01": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E02": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 60 Months / 2000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 2000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E03": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 36 Months / 1000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E04": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 36 Months / 1200 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1200,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E05": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 36 Months / 600 hrs",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E06": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 36 Months / 300 hrs",
    "CoverageAge": 36,
    "CoverageHours": 300,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E07": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage IPS (LXC) - 36 Months / 600 hrs",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E08": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage IPS (LXC) - 36 Months / 1200 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1200,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E100": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) excl Injectors - 60 Months /6000- 10000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 10000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E107": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 6000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E12": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC) - 24 Months / 6000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E15": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC) - 13-36 Months / 5000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 5000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E17": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC) - 13-36 Months / 10000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 400,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E20": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 400 hrs",
    "CoverageAge": 24,
    "CoverageHours": 400,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E21": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 800 hrs",
    "CoverageAge": 24,
    "CoverageHours": 800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E22": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 1200 hrs",
    "CoverageAge": 24,
    "CoverageHours": 1200,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E23": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 1800 hrs",
    "CoverageAge": 24,
    "CoverageHours": 1800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E24": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 2000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 2000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E25": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 2400 hrs",
    "CoverageAge": 24,
    "CoverageHours": 2400,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E26": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 3200 hrs",
    "CoverageAge": 24,
    "CoverageHours": 3200,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E27": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 24 Months / 4000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 4000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E28": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 600 hrs",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E29": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 1200 hrs",
    "CoverageAge": 36,
    "CoverageHours": 10000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E30": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 1800 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E32": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 3000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 3000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E33": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 3600 hrs",
    "CoverageAge": 36,
    "CoverageHours": 3600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E34": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 4800 hrs",
    "CoverageAge": 36,
    "CoverageHours": 4800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E35": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 36 Months / 6000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E36": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 800 hrs",
    "CoverageAge": 48,
    "CoverageHours": 800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E37": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 1600 hrs",
    "CoverageAge": 48,
    "CoverageHours": 1600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E38": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 2400 hrs",
    "CoverageAge": 48,
    "CoverageHours": 2400,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E39": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 3600 hrs",
    "CoverageAge": 48,
    "CoverageHours": 3600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E40": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 4000 hrs",
    "CoverageAge": 48,
    "CoverageHours": 4000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E41": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 4800 hrs",
    "CoverageAge": 48,
    "CoverageHours": 4800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E42": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 6400 hrs",
    "CoverageAge": 48,
    "CoverageHours": 6400,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E43": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 48 Months / 8000 hrs",
    "CoverageAge": 48,
    "CoverageHours": 8000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E44": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E45": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 2000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 2000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E46": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 3000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 3000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E47": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 4500 hrs",
    "CoverageAge": 60,
    "CoverageHours": 4500,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E48": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 6000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E49": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 6000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1200,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E50": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 8000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 8000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E51": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC)  - 60 Months / 10000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 10000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E52": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 24 Months / 400 hrs",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E53": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Drive - 24 Months / 400 hrs",
    "CoverageAge": 24,
    "CoverageHours": 400,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E54": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 24 Months / 800 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1200,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E55": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 36 Months / 600 hrs",
    "CoverageAge": 36,
    "CoverageHours": 3000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E56": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Drive - 36 Months / 600 hrs",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E57": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 36 Months / 1200 hrs",
    "CoverageAge": 24,
    "CoverageHours": 800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E58": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 48 Months / 800 hrs",
    "CoverageAge": 48,
    "CoverageHours": 800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E59": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Drive - 48 Months / 800 hrs",
    "CoverageAge": 48,
    "CoverageHours": 800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E60": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 48 Months / 1600 hrs",
    "CoverageAge": 48,
    "CoverageHours": 1600,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E61": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Drive - 60 Months / 800 hrs",
    "CoverageAge": 60,
    "CoverageHours": 800,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E62": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E63": {
    "CoverageDescriptionManual": "Marine Commercial Extended Coverage (MCXC), AQ/SD Engine - 60 Months / 2000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 2000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E80": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 24 Months / 6000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E81": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC), Major Components - 24 Months / 6000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E82": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC), Major Components - 24 Months 6000-10000 /  hrs",
    "CoverageAge": 24,
    "CoverageHours": 10000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E83": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 36 Months / 3000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 3000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E84": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 36 Months / 6000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E85": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC), Major Components - 36 Months / 6000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E86": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC), Major Components - 36 Months / 6000-10000",
    "CoverageAge": 36,
    "CoverageHours": 10000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E87": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 60 Months / 3000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 3000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E88": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 60 Months / 6000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E89": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC), Major Components - 60 Months / 6000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 6000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E90": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC), Major Components - 60 Months / 6000-10000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 10000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E91": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 24 Months / 4000 hrs",
    "CoverageAge": 24,
    "CoverageHours": 4000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E93": {
    "CoverageDescriptionManual": "Marine Commercial Ext Coverage (MCXC) - US/CA, R3, 4, 5 36 Months / 1500 hrs",
    "CoverageAge": 36,
    "CoverageHours": 1500,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "E94": {
    "CoverageDescriptionManual": "Industrial Extended Coverage (IXC) - 36 Months / 4000 hrs",
    "CoverageAge": 36,
    "CoverageHours": 4000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "EC007": {
    "CoverageDescriptionManual": "Extension Major Component, from 60 to 66 months/total 1000 hours",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "EC008": {
    "CoverageDescriptionManual": "Extension Major Component, from 60 to 69 months/total 1000 hours",
    "CoverageAge": 69,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "EC009": {
    "CoverageDescriptionManual": "Extension Major Component, from 60 to 72 months/total 1000 hours",
    "CoverageAge": 72,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "EC010": {
    "CoverageDescriptionManual": "Extension Major Component, from 60 to 75 months/total 1000 hours",
    "CoverageAge": 75,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "EC021": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 27 months/total 600 hours",
    "CoverageAge": 27,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC022": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 30 months/total 600 hours",
    "CoverageAge": 30,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC023": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 33 months/total 600 hours",
    "CoverageAge": 33,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC024": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 36 months/total 600 hours",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC025": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 39 months/total 600 hours",
    "CoverageAge": 39,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC031": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 27 months/total 1000 hours",
    "CoverageAge": 27,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC032": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 30 months/total 1000 hours",
    "CoverageAge": 30,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC034": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 36 months/total 1000 hours",
    "CoverageAge": 36,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC035": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 39 months/total 1000 hours",
    "CoverageAge": 39,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC040": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 54 months/total 1000 hours",
    "CoverageAge": 54,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC043": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 60 to 84 months/total 500 hours",
    "CoverageAge": 84,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC102": {
    "CoverageDescriptionManual": "Extension Extended Coverage  from 60 to 66 months/total 1000h",
    "CoverageAge": 66,
    "CoverageHours": 1000,
    "IconText": "",
    "IconType": ""
  },
  "EC103": {
    "CoverageDescriptionManual": "Extension Extended Coverage from 60 to 66 months/2000h",
    "CoverageAge": 66,
    "CoverageHours": 2000,
    "IconText": "",
    "IconType": ""
  },
  "EC104": {
    "CoverageDescriptionManual": "Extension Extended Coverage from 60 to 72 months/2000h",
    "CoverageAge": 72,
    "CoverageHours": 2000,
    "IconText": "",
    "IconType": ""
  },
  "EC207": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24m to 30m/from 3000 to 3500 hours",
    "CoverageAge": 30,
    "CoverageHours": 3500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC212": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24m to 30m/from 3000 to 6000 hours",
    "CoverageAge": 30,
    "CoverageHours": 6000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC214": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24m to 36m/from 3000 to 3500 hours",
    "CoverageAge": 36,
    "CoverageHours": 3500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC233": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24m to 48m/from 3000 to 6000 hours",
    "CoverageAge": 48,
    "CoverageHours": 6000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "EC248": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24m to 36m/Unlimited",
    "CoverageAge": 36,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "ECW01": {
    "CoverageDescriptionManual": "Ext Contractual Wty (SCG) 36month/2400h (DC 19)",
    "CoverageAge": 36,
    "CoverageHours": 2400,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "ECW02": {
    "CoverageDescriptionManual": "Ext Contractual Wty (IPS900 QUAD) 60month/12500h (DC 19)",
    "CoverageAge": 60,
    "CoverageHours": 12500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "ECW04": {
    "CoverageDescriptionManual": "Ext Contractual Wty (Brazil ML) 60month/Unlimited hrs (DC 19)",
    "CoverageAge": 60,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "M02": {
    "CoverageDescriptionManual": "Engine Major Components Warranty (+3) - 60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "M03": {
    "CoverageDescriptionManual": "Engine Major Components Warranty (+3) - 60 Months / 2000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "M04": {
    "CoverageDescriptionManual": "Reverse gear/S-drive/IPS Major Components Warranty (+3) - 60 Months / 1000 hrs (Only valid for products with Volvo Penta serial numbers)",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "M05": {
    "CoverageDescriptionManual": "Reverse gear/IPS Major Components Warranty (+3) - 60 Months / 2000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 2000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "M06": {
    "CoverageDescriptionManual": "Reverse gear/Stern Drive/IPS Major Components Warranty (+3) - 60 Months / 2000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 2000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "M07": {
    "CoverageDescriptionManual": "Engine Major Components Warranty (+3) - 60 Months / 4000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 4000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "M08": {
    "CoverageDescriptionManual": "Reverse gear/IPS Major Components Warranty (+3) - 60 Months / 4000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 4000,
    "IconText": "Major components",
    "IconType": "Components"
  },
  "NA01": {
    "CoverageDescriptionManual": "OceanX (only) - 48 Months / Unlimited hrs (1st year, DC10)",
    "CoverageAge": 48,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA011": {
    "CoverageDescriptionManual": "OceanX (only) - 48 Months / Unlimited hrs (2nd year, DC18)",
    "CoverageAge": 48,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA02": {
    "CoverageDescriptionManual": "Gas Bobtail Leisure (engine only components) - 12 Months / 300 hrs",
    "CoverageAge": 12,
    "CoverageHours": 300,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA03": {
    "CoverageDescriptionManual": "Gas EPA (US only), Emission controlled components - 36 Months / 480 hrs",
    "CoverageAge": 36,
    "CoverageHours": 480,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA04": {
    "CoverageDescriptionManual": "Marine Leisure Gas Emission Control system Warranty – 36 Month / 480 hrs",
    "CoverageAge": 36,
    "CoverageHours": 480,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA05": {
    "CoverageDescriptionManual": "Gas Factory Protection program (2013 and newer hulls) - 60 Months / 480 hrs",
    "CoverageAge": 60,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA051": {
    "CoverageDescriptionManual": "Gas Factory Protection program (2013 and newer hulls) - 60 Months / Unlimited hours",
    "CoverageAge": 60,
    "CoverageHours": 99999,
    "IconText": "",
    "IconType": ""
  },
  "NA052": {
    "CoverageDescriptionManual": "Monterey Protection Plan - 84 Months/480 hrs",
    "CoverageAge": 84,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA053": {
    "CoverageDescriptionManual": "Gas Factory Protection program (2013 and newer hulls) - 60 Months / 750 hrs",
    "CoverageAge": 60,
    "CoverageHours": 750,
    "IconText": "",
    "IconType": ""
  },
  "NA06": {
    "CoverageDescriptionManual": "Industrial Emission Components Warranty - 60 Months / 3000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 3000,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA07": {
    "CoverageDescriptionManual": "Marine Leisure Diesel Emission Components Warranty - 60 Months / 500 hrs",
    "CoverageAge": 60,
    "CoverageHours": 500,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA08": {
    "CoverageDescriptionManual": "Marine Commercial Diesel Emission Components Warranty - 60 Months / 2500 hrs",
    "CoverageAge": 60,
    "CoverageHours": 2500,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA09": {
    "CoverageDescriptionManual": "Marine Commercial Diesel Emission Components Warranty - 60 Months / 5000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 5000,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA10": {
    "CoverageDescriptionManual": "Marine Leisure Diesel Emission Components Warranty - 60 Months / 800 hrs",
    "CoverageAge": 60,
    "CoverageHours": 800,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA11": {
    "CoverageDescriptionManual": "Marine Leisure Diesel Emission Components Warranty - 60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA12": {
    "CoverageDescriptionManual": "Gas EPA (US only), Emission controlled components (Outboard) - 36 Months / 500 hrs",
    "CoverageAge": 36,
    "CoverageHours": 500,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA13": {
    "CoverageDescriptionManual": "Gas CARB (only applies i California), Emission controlled components (Outboard) - 36 Months / 500 hrs",
    "CoverageAge": 36,
    "CoverageHours": 500,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA15": {
    "CoverageDescriptionManual": "Gas EPA (US only), Emission controlled components (Outboard) - 36 Months / Unlimited",
    "CoverageAge": 36,
    "CoverageHours": 99999,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA151": {
    "CoverageDescriptionManual": "Gas CARB (only applies i California), Emission controlled components (Outboard) - 36 Months / Unlimited",
    "CoverageAge": 36,
    "CoverageHours": 99999,
    "IconText": "Emission",
    "IconType": "Emission"
  },
  "NA16": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60 Month/ -1000h (DC18)",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA161": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60 Months and -500h (DC18)",
    "CoverageAge": 60,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA164": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -36 Months and -1000h (DC18)",
    "CoverageAge": 36,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA201": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 63 months/total 480 hour",
    "CoverageAge": 63,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA202": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 66 months/total 480 hour",
    "CoverageAge": 66,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA203": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 69 months/total 480 hours",
    "CoverageAge": 69,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA204": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 72 months/total 480 hours",
    "CoverageAge": 72,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA205": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 75 months/total 480 hours",
    "CoverageAge": 75,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA208": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 84 months/total 480 hours",
    "CoverageAge": 84,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA210": {
    "CoverageDescriptionManual": "Extension Factory Protection, from 60 to 90 months/total 480 hour",
    "CoverageAge": 90,
    "CoverageHours": 480,
    "IconText": "",
    "IconType": ""
  },
  "NA211": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 27 months/total 480 hour",
    "CoverageAge": 27,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA212": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 30 months/total 480 hour",
    "CoverageAge": 30,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA214": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 36 months/total 480 hour",
    "CoverageAge": 36,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA215": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 39 months/total 480 hour",
    "CoverageAge": 39,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA220": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 54 months/total 480 hour",
    "CoverageAge": 54,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA221": {
    "CoverageDescriptionManual": "Extension Standard Warranty, from 24 to 84 months/total 480 hour",
    "CoverageAge": 84,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "NA223": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/Unlimited",
    "CoverageAge": 60,
    "CoverageHours": 99999,
    "IconText": "",
    "IconType": ""
  },
  "NA225": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/1000h",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "",
    "IconType": ""
  },
  "NA226": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/1200 hour",
    "CoverageAge": 60,
    "CoverageHours": 1200,
    "IconText": "",
    "IconType": ""
  },
  "NA227": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/1500 hour",
    "CoverageAge": 60,
    "CoverageHours": 1500,
    "IconText": "",
    "IconType": ""
  },
  "NA228": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/2500 hour",
    "CoverageAge": 60,
    "CoverageHours": 2500,
    "IconText": "",
    "IconType": ""
  },
  "NA229": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/1250 hour",
    "CoverageAge": 60,
    "CoverageHours": 1250,
    "IconText": "",
    "IconType": ""
  },
  "NA230": {
    "CoverageDescriptionManual": "Warranty Extension (Outboard) -60m/ from 500 to 550h",
    "CoverageAge": 60,
    "CoverageHours": 550,
    "IconText": "",
    "IconType": ""
  },
  "NAE01": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 25-60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "NAE03": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 25-60 Months / Unlimited hrs",
    "CoverageAge": 60,
    "CoverageHours": 99999,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "NAE11": {
    "CoverageDescriptionManual": "Marine Leisure Extended Coverage (LXC) - 25-72 Months / 1000 hrs",
    "CoverageAge": 72,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "NAE90": {
    "CoverageDescriptionManual": "Extended Warranty 12m (71-84 Months) /1000 hrs",
    "CoverageAge": 84,
    "CoverageHours": 1000,
    "IconText": "Extended",
    "IconType": "Extended"
  },
  "P01": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / Unlimited hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Year one unrestricted",
    "IconType": "Standard"
  },
  "P011": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 3000 hrs (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 3000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P02": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 500 hrs",
    "CoverageAge": 12,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P021": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 500 hrs - Engine Only",
    "CoverageAge": 12,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P03": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 800 hrs",
    "CoverageAge": 12,
    "CoverageHours": 800,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P04": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 1000 hrs",
    "CoverageAge": 12,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P05": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 3000 hrs",
    "CoverageAge": 12,
    "CoverageHours": 3000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P06": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 600 hrs (1st year, DC 10)",
    "CoverageAge": 12,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P061": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 600 hrs (2nd year, DC 18)",
    "CoverageAge": 24,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P062": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 480 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P063": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 480 hrs (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P07": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 1000 hrs (1st year, DC 10)",
    "CoverageAge": 12,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P071": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 1000 hrs (2nd year, DC 18)",
    "CoverageAge": 24,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P08": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / Unlimited hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Year one unrestricted",
    "IconType": "Standard"
  },
  "P081": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 3000 hrs (2nd year, DC 18)",
    "CoverageAge": 24,
    "CoverageHours": 3000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P09": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 2000h",
    "CoverageAge": 12,
    "CoverageHours": 2000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P10": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 5000 hrs",
    "CoverageAge": 12,
    "CoverageHours": 5000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P11": {
    "CoverageDescriptionManual": "Marine Commercial Gas Limited Warranty - 6 Months / 400 hours",
    "CoverageAge": 6,
    "CoverageHours": 400,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P12": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / Unlimited (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Year one unrestricted",
    "IconType": "Standard"
  },
  "P132": {
    "CoverageDescriptionManual": "Factory Protection program (Tiara) - 60 Months / 500 hrs",
    "CoverageAge": 60,
    "CoverageHours": 500,
    "IconText": "",
    "IconType": ""
  },
  "P14": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty (Outboard)  - 12 Months / 350 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 360,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P15": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty (Outboard)  - 36 Months / 500 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P151": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty (Outboard)  - 36 Months / 500 hrs (2nd-3rd year, DC18)",
    "CoverageAge": 36,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P16": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty (Outboard)  - 36 Months / Unlimited (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P161": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty (Outboard) - 36 Months /Unlimited (2nd-3rd year, DC18)",
    "CoverageAge": 36,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P17": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 1000 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P18": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P181": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P182": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 600 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P20": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 4000 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 4000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "P201": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 4000 hrs (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 4000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RM001": {
    "CoverageDescriptionManual": "Volvo Penta RMC - 36 months / 1200 hours",
    "CoverageAge": 36,
    "CoverageHours": 1200,
    "IconText": "",
    "IconType": ""
  },
  "RM002": {
    "CoverageDescriptionManual": "Volvo Penta RMC - 36 months / 600 hours",
    "CoverageAge": 36,
    "CoverageHours": 600,
    "IconText": "",
    "IconType": ""
  },
  "RM003": {
    "CoverageDescriptionManual": "Fluid Motion Service Promotion 24 month/ 200 hours",
    "CoverageAge": 24,
    "CoverageHours": 200,
    "IconText": "",
    "IconType": ""
  },
  "RP06": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 600 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP061": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 600 hrs (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 600,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP062": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 480 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP063": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 480 hrs (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 480,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP064": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 500 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 500,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP065": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty - 12 Months / 800 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 800,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP07": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 1000 hrs (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP071": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months / 1000 hrs (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 1000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP09": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 12 Months / 2000h (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 2000,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP18": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months (1st year, DC10)",
    "CoverageAge": 12,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP181": {
    "CoverageDescriptionManual": "Volvo Penta Limited Warranty  - 24 Months (2nd year, DC18)",
    "CoverageAge": 24,
    "CoverageHours": 99999,
    "IconText": "Standard",
    "IconType": "Standard"
  },
  "RP401": {
    "CoverageDescriptionManual": "Reverse gear/S-drive/IPS Major Components Warranty (+3) - 60 Months / 1000 hrs",
    "CoverageAge": 60,
    "CoverageHours": 1000,
    "IconText": "Major components",
    "IconType": "Components"
  }
}
